import { Component, Input } from '@angular/core';

import { CustomerReservationPaymentStatus } from '../../../../../models/customer';

/**
 * Renders a reservation/booking payment status as coloured text, optionally
 * followed by the invoice reference (PRO-1338). Shared so an unmatched status
 * cannot render as an empty cell indistinguishable from "no payment". The
 * host is display:contents (see the css) so it adds no element box.
 */
@Component({
  selector: 'app-payment-status-badge',
  templateUrl: './payment-status-badge.component.html',
  styleUrls: ['./payment-status-badge.component.css'],
})
export class PaymentStatusBadgeComponent {
  @Input() status: CustomerReservationPaymentStatus;

  // When set, "(Ref <id>)" is rendered after the status.
  @Input() invoiceId: number | null = null;

  public getStatusDisplay(): string {
    switch (this.status) {
      case CustomerReservationPaymentStatus.paymentPending: return 'Incomplete';
      case CustomerReservationPaymentStatus.depositPaid: return 'Deposit Paid';
      case CustomerReservationPaymentStatus.paymentComplete: return 'Complete';
      case CustomerReservationPaymentStatus.refunded: return 'Refunded';
      case CustomerReservationPaymentStatus.partiallyRefunded: return 'Partially Refunded';
      case CustomerReservationPaymentStatus.cancelled: return 'Cancelled';
      default: return this.status;
    }
  }

  public getStatusClass(): string {
    switch (this.status) {
      case CustomerReservationPaymentStatus.paymentPending: return 'text-danger font-weight-bold';
      case CustomerReservationPaymentStatus.depositPaid: return 'text-warning';
      case CustomerReservationPaymentStatus.paymentComplete: return 'text-success';
      default: return 'text-muted';
    }
  }
}
